export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9084.c6d9f135.jpg";